import store from '@/store/index.js'
import { makeRequest } from '@/libs/RequestModule'
import { log } from '@/libs/Logger.js'

const getInvoices = async (CDCONSUMIDOR) => {
    await makeRequest('getInvoices', { CDCONSUMIDOR })
        .then(response => {
            if (response?.sucesso && response.data) {
                store.dispatch('setInvoiceData', response.data)
            } else {
                log({ type: 'error', message: `Resposta inesperada em getInvoices: ${JSON.stringify(response)}` })
            }
        })
        .catch(error => {
            log({ type: 'error', message: `Erro em getInvoices:\n${error.message}` })
        })
        .finally(() => {
            store.dispatch('stopInvoiceLoading')
        })
}

export { getInvoices }
